import Hero from "../components/Hero";
import Services from "../components/Services";
import About from "../components/About";
import Portfolio from "../components/Portfolio";
import Testimonials from "../components/Testimonials";
import Team from "../components/Team";
import CTA from "../components/CTA";

const Home = () => {
	return (
		<div className="home-page pt-[80px] lg:pt-0">
			<Hero />
			<Services limit={6} titleHead />
			<About titleHead />
			<Portfolio />
			<Testimonials />
			<Team />
			<CTA />
		</div>
	);
};

export default Home;
